<template>
 <div class="logo fw4 z-3 fixed brown title title-ns">
    <img
      src="../assets/images/logo.png"
      v-scroll="handleScroll"
    />
  </div>
</template>

<script>
export default {
  name: 'Logo',
  data () {
    return {
    }
  },
  methods: {
    handleScroll: (evt, el) => {
      var scrollPos = window.scrollY
      var winHeight = window.innerHeight
      var docHeight = document.documentElement.scrollHeight
      var perc = scrollPos / (docHeight - winHeight)

      el.setAttribute(
        'style',
        `transform: rotate(${Math.PI * 2 * perc}rad);`
      )
    }
  },
  directives: {
    scroll: {
      inserted: function (el, binding) {
        let f = function (evt) {
          if (binding.value(evt, el)) {
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
      }
    }
  }
}

</script>

<style scoped>
  .logo {
    pointer-events: none;
  }
</style>
